import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Popup } from 'semantic-ui-react'
import { SwatchesPicker } from 'react-color'
import material from 'material-colors'

import './ColorPicker.css'

class ColorPicker extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      hex: props.hex || 'FFFFFF',
      open: false
    }

    // Bind events
    this.onSelect = this.onSelect.bind(this)
    this.onOpen = this.onOpen.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.hex !== this.state.hex) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.hex)
      }
    }

    // Bubble parent change to local
    if (prevProps.hex !== this.props.hex) {
      this.setState({
        hex: this.props.hex
      })
    }
  }

  onSelect(color, event) {
    const hex = color.hex.replace('#', '').toUpperCase()
    this.setState({
      hex,
      open: false
    })
  }

  onOpen() {
    this.setState({
      open: true
    })
  }

  onClose() {
    this.setState({
      open: false
    })
  }

  render() {
    return (
      <Popup
        trigger={
          <div
            className='library-color-picker'
            style={{
              backgroundColor: '#' + this.state.hex
            }}
          />
        }
        hideOnScroll={false}
        flowing={true}
        on='click'
        open={this.state.open}
        onOpen={this.onOpen}
        onClose={this.onClose}
        position='top center'
      >
        <SwatchesPicker
          color={'#' + this.state.hex}
          onChangeComplete={this.onSelect}
          width={340}
          height={260}
          colors={[
            [
              material.red['900'],
              material.red['700'],
              material.red['500'],
              material.red['300'],
              material.red['100']
            ],
            [
              material.pink['900'],
              material.pink['700'],
              material.pink['500'],
              material.pink['300'],
              material.pink['100']
            ],
            [
              material.purple['900'],
              material.purple['700'],
              material.purple['500'],
              material.purple['300'],
              material.purple['100']
            ],
            [
              material.indigo['900'],
              material.indigo['700'],
              material.indigo['500'],
              material.indigo['300'],
              material.indigo['100']
            ],
            [
              material.blue['900'],
              material.blue['700'],
              material.blue['500'],
              material.blue['300'],
              material.blue['100']
            ],
            [
              material.teal['900'],
              material.teal['700'],
              material.teal['500'],
              material.teal['300'],
              material.teal['100']
            ],
            [
              '#194D33',
              material.green['700'],
              material.green['500'],
              material.green['300'],
              material.green['100']
            ],
            [
              material.lime['900'],
              material.lime['700'],
              material.lime['500'],
              material.lime['300'],
              material.lime['100']
            ],
            [
              material.yellow['900'],
              material.yellow['700'],
              material.yellow['500'],
              material.yellow['300'],
              material.yellow['100']
            ],
            [
              material.orange['900'],
              material.orange['700'],
              material.orange['500'],
              material.orange['300'],
              material.orange['100']
            ],
            [
              material.deepOrange['900'],
              material.deepOrange['700'],
              material.deepOrange['500'],
              material.deepOrange['300'],
              material.deepOrange['100']
            ],
            [
              material.brown['900'],
              material.brown['700'],
              material.brown['500'],
              material.brown['300'],
              material.brown['100']
            ],
            [
              material.blueGrey['900'],
              material.blueGrey['700'],
              material.blueGrey['500'],
              material.blueGrey['300'],
              material.blueGrey['100']
            ],
            [
              '#000000',
              '#525252',
              '#969696',
              '#D9D9D9',
              '#FFFFFF'
            ]
          ]}
        />
      </Popup>
    )
  }
}

ColorPicker.propTypes = {
  hex: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/elements/ColorPicker.js